export const environment = {
  production: true,
  apiUrl: `https://${window.location.hostname}/api/`,
  envName: "prod"
};